import bnbIcon from '../assets/new-ui/bnb-icon.png'

export const PROXY_CONTRACT_ADDRESS ='0xadC08f39502feB79EaD2fC530ce32727D0BFdCb5'
const IMPLEMENTATION_CONTRACT_ADDRESS = '0xC6B9f1EbDbB82Ac3B84B7230D9d6D478A3cb8e33'
const BSCSCAN_API_KEY= 'PAJNMIZND56W3DUYAWDNNUJYQHUPF1SFYB'

export const url = {
  contract_abi_url: 'https://api-testnet.bscscan.com/api?module=contract&action=getabi&address=' + IMPLEMENTATION_CONTRACT_ADDRESS + '&apikey=' + BSCSCAN_API_KEY,
  storage_metadata_url: 'https://storage.holysharks.io/nft/metadata',
  api_mint_nft: 'https://api.holysharks.io/generate-nft/check',
  bsc_testnet_explore: 'https://testnet.bscscan.com/tx',
  marketplace_url: 'https://api.holysharks.io/marketplace',
  holysharks_url: 'https://api.holysharks.io'
} 

export const MIN_NFT = 1;
export const MAX_NFT = 5;

export const MINT_PRICE = 0.008

// Status Filter
export const STATUS_ALL = 'All'
export const STATUS_BUY_NOW = 'LISTED'
export const STATUS_DELISTED = 'DELISTED'
export const STATUS_ON_AUCTION = 'AUCTION'

export const statusFilterList = [STATUS_ALL,STATUS_ON_AUCTION,STATUS_BUY_NOW]

// Collections Filter
export const COLLECTION_ALL = 'All'
export const SHARK = 'Shark'

export const collectionFilterList = [COLLECTION_ALL,SHARK]

// Rarity Filter
export const RARITY_ALL = 'All'
export const RARITY_NORMAL = 'Normal'
export const RARITY_UNCOMMON = 'Uncommon'
export const RARITY_RARE = 'Rare'
export const RARITY_EPIC = 'Epic'
export const RARITY_LEGENDARY = 'Legendary'
export const RARITY_MYTHIC = 'Mythic'
export const RARITY_UNIQUE = 'Unique'
export const RARITY_DEMI_GOD = 'Demi-God'
export const RARITY_GOD = 'God'

export const rarityFilterList = [
  RARITY_ALL,
  RARITY_NORMAL,
  RARITY_UNCOMMON,
  RARITY_RARE,
  RARITY_EPIC,
  RARITY_LEGENDARY,
  RARITY_MYTHIC,
  RARITY_UNIQUE,
  RARITY_DEMI_GOD,
  RARITY_GOD
]

//Price Filter
export const ALL_UNIT = `All`
export const BNB_UNIT = `<img src=${bnbIcon} alt='' /> BNB`
export const priceFilterList = [ALL_UNIT,BNB_UNIT]

export const BNB_USD_RATE = 600

export const BNB_DECIMAL = 1000000000000000000

//Sort Type
export const sortType = {
  all: 'All',
  priceInc: 'Price ↑',
  priceDes: 'Price ↓',
  idInc: 'Id ↑',
  idDes: 'Id ↓',
  rarityInc: 'Rarity ↑',
  rarityDes: 'Rarity ↓'
}